export function open(url) {
    window.open(url, "_blank");
}
export const iOS = navigator.userAgent.indexOf("iPhone") !== -1 || navigator.userAgent.indexOf("iPad") !== -1;
